import React, { memo } from 'react'

import GridItem from './GridItem'

const GridData = ({ data, sx }) => {
  return data.map((item, index) => <GridItem key={index} sx={sx} {...item} />)
}

export default memo(GridData)
